module.exports = "https://static.wmbcdn.com/uniweb/images/e18891ebe3003a441e983d40a87f14c6.svg";